import { AppStrings } from '../messages';

export const German: AppStrings = {
    or: ' oder ',
    max: 'max.',
    accept: 'Akzeptieren',
    submit: 'Absenden',
    back: 'Zurück',
    purchase: 'Kostenpflichtig buchen',
    no_thanks: 'Nein danke',
    thank_you: 'Danke!',
    cancel: 'Abbrechen',
    close: 'Schließen',
    click_here_to_get_code: 'Klicken Sie hier, um Ihren Code zu erhalten',
    open: 'Offen',
    option_unavailable: 'Diese Option ist derzeit nicht verfügbar',
    confirm: 'Bestätigen Sie',

    my_trip: 'Meine Reise',
    finalize_trip: 'Beende deine Reise',
    trip_all_set: 'Deine Reise ist fertig',
    manage_guests_capitalized: 'Gasten Uitnodigen',
    manage_guests_title: 'Gasten uitnodigen',
    manage_pets_title: 'Honden Toevoegen/Verwijderen',
    manage_pets_error: 'Leider ist ein Fehler aufgetreten. Um mit einem Kundendienstmitarbeiter zu sprechen, rufen Sie 1-800-544-0300 an.',
    add_remove_guest: 'Gast hinzufügen oder entfernen',
    modify_your_trip: 'Ändern Sie Ihre Reise',
    instructions_for_modify_guests:
        'Teilen Sie uns mit, wie viele Erwachsene und Kinder (über 2 Jahre) übernachten werden. Wenn Ihre Pläne noch nicht abgeschlossen sind, fügen Sie die Gäste hinzu, die Sie derzeit kennen. Sie können später zurückkehren und diese Informationen aktualisieren.',
    instructions_for_modify_guests_pets:
        'Teilen Sie uns mit, wie viele Erwachsene, Kinder (über 2 Jahre) und Hunde werden bleiben. Wenn Ihre Pläne noch nicht abgeschlossen sind, fügen Sie die Gäste hinzu, die Sie derzeit kennen. Sie können später zurückkehren und diese Informationen aktualisieren.',
    instructions_for_modify_pets: 'Harige vriend en kwispelende staarten zijn welkom. Voeg maximaal {pets} honden toe aan uw verblijf.',
    instructions_for_modify_pet: 'Harige vriend en kwispelende staarten zijn welkom. Voeg maximaal 1 hond toe aan uw verblijf.',
    extra_instructions_for_modify_pet:
        'Van gedachten veranderen? We betalen je eventueel betaalde huisdiertoeslagen binnen 5 werkdagen terug.',
    max_occupancy_modify_guests:
        'max. Belegung ist {max_occupancy} {guests}. Es können zusätzliche Gebühren anfallen, die unten angezeigt werden.',
    getting_there: 'Anreise',
    in_the_home: 'Ihre Unterkunft',
    checkout_instructions: 'Check-out Hinweise',
    codes_will_be_provided: 'Die Codes erhalten Sie 1 Woche vor Ihrem Anreisedatum',
    passwords_will_be_provided: 'Das Passwort erhalten Sie 1 Woche vor Ihrem Anreisedatum',
    alarm_code: 'Alarmcode',
    lockbox_code: 'Schließfach-Code',
    e_lock_codes: 'E-Lock Codes',
    gate_access: 'Zugang zum Tor',
    stay_longer: 'Bleiben Sie ein bisschen länger',
    location_and_parking: 'Lage & parken',
    on_your_way: 'Unterwegs',
    directions_to_know: 'Anfahrt zu wissen',
    directions_and_parking_notes: 'Wegbeschreibung & Parkmöglichkeiten',
    parking_spaces: 'Parkplätze',
    parking_notes: 'Parkhinweise',
    entering_home: 'Unterkunft beziehen',
    home_access_details: 'Infos zum Zugang zur Unterkunft',
    house_rules: 'Hausregeln',
    internet_access: 'Internetzugang',
    network: 'Netzwerk',
    password: 'Passwort',
    reservation: 'Buchung',
    trip_overview: 'Reiseübersicht',
    nights: 'Nächte',
    max_occupancy: 'Max. Belegung',
    can_add_guest: 'Sie können bis zu {total} weitere {guests} hinzufügen',
    can_not_add_guest: 'Du hast die maximale Gästezahl erreicht',
    guest: 'Gast',
    guests: 'Gäste',
    confirmation: 'Bestätigung',
    view_listing: 'Liste ansehen',

    print_header_text:
        'Bitte folgen Sie diesen Anweisungen. Sie werden benachrichtigt, sobald wir Ihre Zustimmung erhalten und verarbeitet haben',
    print_step_one: 'Drucken Sie diese Vereinbarung aus, überprüfen Sie sie und unterschreiben Sie sie',
    print_step_two: 'Senden Sie es uns per E-Mail oder Fax zurück',
    print_button: 'Drucken',
    print_email_label: 'Email',
    print_fax_label: 'Fax',
    print_email_value: 'info@vacasa.com',
    print_fax_value: '(503) 897-7036',
    print_booked_by: 'Gebucht von',
    print_on: 'auf',
    rental_agreement: 'Mietvertrag',
    sign_agreement: 'Vertrag unterschreiben',
    sign_by: 'Überprüfen und unterschreiben {signBy}',
    sign_agreement_by: 'Bitte unterschreiben Sie Ihren Mietvertrag mit allen Angaben bis zum {signBy}',
    signed_on: 'Unterschrieben am {signedOn}',
    i_agree_terms: 'Ich stimme den oben genannten Bedingungen zu',
    agreed_on: 'Sie haben diesen Bedingungen am {agreedOn} zugestimmt',
    i_agree_new_terms: `Ich stimme dem <a target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Mietvertrag</a> von Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Datenschutzrichtlinie</a>, und `,
    agreed_new_terms_on: `Sie haben dem <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Mietvertrag</a> von Vacasa, <a   target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Datenschutzrichtlinie</a>, und `,
    agreed_new_terms_on_date: ` am {date}`,
    unit_terms_text: `Spezifische Bedingungen der Einheit`,
    unit_terms_alert: `Sofern nicht anders in der `,
    new_terms_required_text: `Erforderlich`,
    new_terms_instructions_text: `Überprüfen Sie die Hausregeln und bestätigen Sie die Vereinbarung unten`,
    new_terms_submit_btn: `Absenden`,
    payment_details: 'Zahlungsangaben',
    make_payment: 'Zahlung leisten',
    pay_balance: 'Restbetrag Bezahlen',
    balance_due: 'Fälliger Restbetrag',
    payment_complete: 'Zahlung vollständig',
    pay_by: '{total} fällig bis {payBy}',
    pay_balance_by: 'Bezahlen Sie Ihr Guthaben bis {payBy}',
    view_receipt: 'Beleg ansehen',

    refund_going_to: 'Rückerstattung geht an',
    original_payment_methods: 'Ursprüngliche Zahlungsmethode(n)',
    guest_paid: 'Gast hat {amount} am {date} bezahlt',
    refund_details: 'Rückerstattungsdetails',
    total_refund: 'Gesamtrückerstattung',
    original_payment: 'Ursprüngliche Zahlung',

    cancellation_charges: 'Stornierungsgebühren',
    sure_you_want_to_cancel: 'Möchten Sie Ihre Reise wirklich stornieren?',
    yes_cancel_now: 'Ja, jetzt kündigen.',
    no_dont_cancel: 'Nein, nicht stornieren.',
    cancel_trip: 'Reise stornieren',
    cancel_and_receive_refund: 'Stornieren & Rückerstattung erhalten',
    view_cancellation_policy: 'Stornierungsrichtlinie anzeigen',

    balance_in: 'Restbetrag in {currency}',
    total_in: 'Gesamtbetrag in {currency}',
    total_with_security_deposit_in: 'Gesamtbetrag mit Sicherheitseinlage in {currency}',
    security_deposit: 'Sicherheitseinlage',
    new_balance_due: 'Neues Guthaben in {Währung}',
    processed_in_currency_notice:
        'Bitte beachten Sie, dass diese Transaktion in {currency} abgewickelt wurde. Umrechnungskurse sind variable Näherungswerte.',
    vehicle_registration: 'Kfz-Zulassung',
    vehicle: 'Fahrzeug',
    list_your_vehicles: 'Die Fahrzeuge Ihrer Gruppe',
    register_vehicle: 'Fahrzeug registrieren',
    max_vehicles_reached: 'Maximale Fahrzeugzahl erreicht',
    group_has_no_vehicles: 'Meine Gruppe hat keine Fahrzeuge',
    register_by: 'Alle Fahrzeuge bis {registerBy} hinzufügen',
    register_vehicles_by: 'Bitte registrieren Sie Ihre Fahrzeuge bis zum {registerBy}',
    add_vehicle_info: 'Fahrzeugangaben hinzufügen',
    add_a_vehicle_button: 'Fahrzeug hinzufügen',
    add_vehicle_title: 'Ein Fahrzeug hinzufügen',
    add_vehicle_text: 'Fügen Sie zu Ihrer Reise ein Fahrzeug hinzu.',
    vehicle_added: 'Fahrzeugangaben hinzugefügt',
    edit_a_vehicle_button: 'Änderungen Cpeichern',
    edit_vehicle_title: 'Ein Fahrzeug bearbeiten',
    edit_vehicle_text: 'Bearbeiten Sie Ihre Fahrzeugangaben.',
    remove_vehicle_text: 'Entfernen Sie für Ihre Reise ein Fahrzeug.',
    remove_vehicle_title: 'Ein Fahrzeug entfernen',
    remove_vehicle_button: 'Entfernen',
    my_group_has_no_vehicles_title: 'Meine Gruppe hat kein Fahrzeug',
    my_group_has_no_vehicles_confirm_text:
        'Sie können von der Stadt oder der HOA mit einer Geldstrafe belegt werden, wenn Ihre Gruppe ein Fahrzeug ohne vorherige Registrierung mitbringt.',
    my_group_has_no_vehicles_confirm_button: 'Bestätigen Sie keine Fahrzeuge',
    license_plate: 'Kennzeichen',
    state_province: 'Staat/Provinz',
    other: 'Andere',
    location: 'Ort',

    add_on: 'Zusatzangaben',
    pool_heat: 'Poolbeheizung',
    pool_heat_added: 'Poolbeheizung hinzugefügt',
    pool_heat_note:
        'Verbessern Sie Ihren Aufenthalt mit unserem Poolheizungs-Upgrade! Tauchen Sie in Komfort und Wärme bei jedem Schwimmen ein.',
    finalize_your_reservation: 'Buchung abschließen',
    these_actions_are_required: 'Sie müssen diese Aktionspunkte ausführen, um Ihre Check-in-Details zu erhalten.',

    need_help: 'Benötigen Sie Hilfe?',
    visit_our: 'Besuchen Sie unseren',
    support_center: 'Hilfecenter',
    still_have_questions: 'Sie haben immer noch Fragen?',
    please_reach: 'Bitte kontaktieren Sie: ',
    home_essentials: 'Die Unterkunft im Überblick',
    no_beds: 'Keine Betten',
    king_bed: 'kingsize-Bett',
    king_bed_plural: 'kingsize-Betten',
    queen_bed: 'queensize-Bett',
    queen_bed_plural: 'queensize-Betten',
    double_bed: 'doppelbett',
    double_bed_plural: 'doppelbetten',
    twin_bed: 'einzelbett',
    twin_bed_plural: 'einzelbetten',
    child_bed: 'kinderbett',
    child_bed_plural: 'kinderbetten',
    murphy_bed: 'schrankbett',
    murphy_bed_plural: 'schrankbetten',

    no_bathrooms: 'Keine Badezimmer',
    full_bath: 'vollbad',
    full_bath_plural: 'vollbäder',
    half_bath: 'halbes Bad',
    half_bath_plural: 'halbe Bäder',
    sleeps: 'Bietet Platz für',

    loading: 'Lädt',
    updated_successfully: 'Erfolgreich aktualisiert',
    read_more: '...Mehr lesen',
    read_less: '...Weniger lesen',
    who_is_coming: 'Wer kommt',
    invite_guest: 'Gast einladen',
    invite_guest_note: 'Eingeladene Gäste erhalten {daysBefore} Tage vor der Reise eine detaillierte Check-in E-Mail.',
    invite_guest_note_same_day: 'Eingeladene Gäste erhalten am Tag der Ankunft eine detaillierte Check-in-E-Mail',
    add_guest: 'Laden Sie einen Gast ein',
    edit_guest: 'Gast bearbeiten',
    remove_guest: 'Gast entfernen',
    edit_guest_note_modal:
        'Bearbeiten Sie die Angaben zu Ihren Gästen, um mit ihnen den Reiseplan und die Zugangsinformationen für diese Reise zu teilen.',
    invite_guest_info: 'Angaben zum Gast hinzufügen',
    email_addresses_guests: 'E-Mail-Adresse',
    modify_guest_note: 'Sie können für Ihre Reise Gäste hinzufügen oder entfernen.',
    modify_guest_add_note: 'Sie können bis zu {remainingGuests} weitere Gäste hinzufügen',
    need_cancel_trip: 'Sie müssen Ihre Reise stornieren?',
    need_cancel_note: 'Wenn Sie Ihre Reise stornieren müssen, lesen Sie bitte hier die entsprechenden Bedingungen.',
    cancel_trip_options: 'Siehe Stornierungsoptionen',
    name: 'Name',
    first_name: 'Vorname',
    last_name: 'Nachname',
    email_address: 'E-Mail-Adresse',
    invite_guest_note_modal:
        'Fügen Sie Ihre Gäste hinzu, um mit ihnen den Reiseplan und die Zugangsinformationen zu dieser Reise zu teilen.',
    yes_remove_invited: 'Ja',
    no_remove_invited: 'Macht nichts',
    can_add_pet: 'Voeg maximaal {total} harige vriend toe',
    can_add_pets: 'Voeg maximaal {total} harige vrienden toe',
    can_not_add_pet: 'Sie haben die maximale Anzahl an Hunden erreicht',
    add_pet_refund_btn: '',
    add_pet_update_balance_title: '',
    add_pet_checkout_title: '',
    pet: 'Hund',
    pets: 'Hunde',
    remove_invite_note: 'wird von der Gästeliste entfernt',
    are_you_sure: 'Sind Sie sicher?',

    cookie_disclaimer:
        'Vacasa verwendet Cookies von Erst- und Drittanbietern. Durch die Nutzung unserer Webseiten stimmen Sie unserer Cookie-Richtlinie zu.',
    read_cookie_policy: 'Lesen Sie unsere Cookie-Richtlinie',
    sitemap: 'Sitemap',
    privacy: 'Datenschutz',
    terms_of_service: 'Nutzungsbedingungen',

    property_management: 'Verwaltung von Ferienunterkünften',
    real_estate: 'Immobilien',
    innovation: 'Innovation',
    company: 'Unternehmen',
    about_us: 'Über uns',
    blog: 'Blog',
    careers: 'Karriere',
    newsroom: 'Newsroom',
    investors: 'Investoren',
    community: 'Gemeinschaft',
    social_responsibility: 'Gesellschaftliche Verantwortung',
    leadership: 'Führung',
    solutions_partnerships: 'Lösungen und Partnerschaften',
    accessibility: 'Barrierefreiheit',
    help: 'Hilfe',
    support_contact: 'Hilfe und Kontakt',
    toll_free: 'Gebührenfrei:',
    local: 'Inland:',
    covid_update: 'COVID-19 Updates',
    hi: 'Hallo ',
    my_trips: 'Meine Reisen',
    favorites: 'Favoriten',
    profile: 'Profil',
    logout: 'Ausloggen',
    owner_portal: 'Hausbesitzer-Konto',
    owner_login: 'Eigentümer-Login',
    login: 'Gast-Anmeldung / Registrierung',
    find_my_trip: 'Meine Reise suchen',
    my_account: 'Anmelden / Registrieren',
    language_and_currency: 'Sprache und Währung',
    somethings_not_right: 'Da stimmt etwas nicht',
    an_error_occurred: 'Während ihrer Anfrage ist ein Fehler aufgetreten',
    try_later_or_call: 'Bitte versuchen Sie es später oder rufen Sie unter der folgenden Nummer Ihren Vacasa Mitarbeiter an:',
    reservation_info_unavailable: 'Information Nicht Verfügbar',

    something_went_wrong: 'Oh oh, etwas ist schief gelaufen',
    error_cancelling: 'Beim Stornieren Ihrer Reservierung ist ein Fehler aufgetreten.',
    contact_customer_service: 'Bitte kontaktieren Sie den Kundenservice unter {phone} für weitere Unterstützung',

    identity_check_required: 'Um fortfahren zu können, ist eine Identitätsprüfung erforderlich.',
    verify_identity: 'Weisen Sie Ihre Identität nach',

    already_completed_idv: 'Haben Sie es schon abgeschlossen?',
    click_here: 'hier klicken',

    guest_portal_unavailable: 'Der Trip Manager ist nicht erreichbar.',
    resolve_issues_calling: 'Um dieses Problem zu lösen, rufen Sie bitte unter der folgenden Nummer Ihren Vacasa Mitarbeiter an:',
    session_expired: 'Sitzung abgelaufen',
    session_expired_message: 'Die Sitzung ist abgelaufen. Sie werden jetzt umgeleitet zu',

    access_token_expired: 'Sitzung abgelaufen',
    access_token_expired_message: 'Die Sitzung ist abgelaufen. Sie werden umgeleitet, um Ihre Sitzung zu aktualisieren.',

    trip_overview_capitalized: 'Reiseübersicht',
    getting_there_capitalized: 'Anreise',
    modify_your_trip_capitalized: 'Reise ändern',
    checkout_instructions_capitalized: 'Check-out Hinweise',
    view_receipt_capitalized: 'Siehe Quittung',
    trip_eligibility_trip_already_started:
        'Wunderbar – Ihre Reise hat begonnen! Wenn Sie Ihre Reise dennoch ändern müssen, rufen Sie bitte unter der folgenden Nummer einen Vacasa Gästebetreuer an:',
    trip_eligibility_pending_payment:
        'Ihre Zahlung wird derzeit verarbeitet. Schauen Sie in 24 Stunden wieder herein, um Ihre Reise zu ändern.',
    trip_eligibility_created_before_june_fourth_2018:
        'Wenn Sie Ihre Reise dennoch ändern müssen, rufen Sie bitte unter der folgenden Nummer einen Vacasa Gästebetreuer an:',
    trip_eligibility_negative_balance:
        'Ihre Rückerstattung wird derzeit verarbeitet. Schauen Sie in 24 Stunden wieder herein, um Ihre Reise zu ändern.',
    trip_eligibility_not_allowed_for_occupancy:
        'Es tut uns leid. Sie können bei dieser Buchung keine Änderungen bei Gästen/Hunden vornehmen.',
    trip_eligibility_refund_in_progress:
        'Sie haben eine Rückerstattung im Gange. Bitte warten Sie, bis die Bearbeitung abgeschlossen ist, um Ihre Belegung zu ändern',

    wheres_my_receipt: 'Wo befindet sich mein Buchungsbeleg?',
    channel_receipt_note:
        'Sie haben Ihre Reservierung über einen unserer Buchungspartner vorgenommen. Bitte wenden Sie sich an das Unternehmen, bei dem Sie gebucht haben, um Ihre Quittung und Zahlungsinformationen zu erhalten.',

    download_app_mobile_note: 'Einfacher Check-in',
    download_app_mobile_title: 'Begleiten Sie uns in der App!',

    view_agreement: 'Vereinbarung anzeigen',

    payment_title: 'Zahlung ausführen',
    receipt_title: 'Beleg',
    addons_title: 'Reise-Ergänzungen',
    latecheckout_title: 'Spätes Auschecken hinzufügen',
    modify_trip_title: 'Reise ändern',

    pool_heat_add_or_remove: 'Poolwärme hinzufügen oder entfernen',

    submit_guest_edition: 'Gastausgabe senden',
    confirm_guest_remove: 'Bestätigen Sie das Entfernen des Gastes',

    ready_to_checkout: '¿Bereit zur Kasse?',
    note_early_checkout:
        'Klicken Sie hier, um zu bestätigen, dass Sie auschecken. Dadurch wird auch unser Housekeeping-Team darüber informiert, dass Sie abgereist sind.',
    checkout_now: 'Checke jetzt aus',
    not_ready_yet: 'Ich bin noch nicht fertig',
    all_set: 'Alles bereit!',
    note_confirm_early_checkout: 'Vielen Dank, Ihr Check-out ist abgeschlossen. Wir hoffen, Sie bald wieder zu begrüßen!',
    got_it: 'Kein Problem',
    note_cancel_early_cehckout:
        'Sie können bis {checkout}. auschecken. Wenn Sie fertig sind, klicken Sie in der von uns gesendeten Textnachricht erneut auf den Link zum Auschecken.',

    rent: 'Miete',
    fees: 'Tarife',
    taxes: 'Steuern',
    trip_protection: 'Reiseschutz',
    not_purchased: 'Nicht gekauft',
    previous_balance: 'Vorheriger Saldo',
    sub_total: 'Zwischensumme',
    pet_refund: 'Hund-Rückerstattung',
    adult_added: 'Erwachsener hinzugefügt',
    adults_added: 'Erwachsene hinzugefügt',
    pet_added: 'Hund hinzugefügt',
    pets_added: 'Hund hinzugefügt',
    child_added: 'Kind hinzugefügt',
    children_added: 'Kinder hinzugefügt',
    child: 'Kind',
    children: 'Kinder',

    payment_processed_by: 'Zahlung bearbeitet von:',
    billing_address: 'Rechnungsadresse:',

    receipt_thirty_party_channel: 'Vielen Dank, dass Sie Ihr Vacasa-Haus über gebucht haben {channel}',

    covid19_text: 'Ein Update zum Coronavirus (COVID-19) und unseren Stornierungsbedingungen',
    covid19_button_text: 'Lesen Sie unsere neuesten Updates',
    covid19_link: 'https://www.vacasa.com/support/coronavirus-covid-19',

    square_feet: 'quadratfuß',

    browser_deprecated: 'Browser wird nicht unterstützt',
    please_upgrade_browser: 'Bitte aktualisieren Sie diese Website oder verwenden Sie einen anderen Browser, um sie anzuzeigen',

    know_before_you_go: 'Wissen Sie, bevor Sie gehen',
    import_details: 'Wichtige Details',
    directions_and_parking_details: 'Wegbeschreibung und Parkdetails',
    note_for_our_guests: 'Hinweise für unsere Gäste',

    cannot_perform_action_title: 'Diese Seite ist momentan nicht verfügbar',
    cannot_perform_action_message: 'Bitte versuchen Sie es später oder rufen Sie unter der folgenden Nummer Ihren Vacasa Mitarbeiter an',

    fsc_credits: 'Future Stay Credits',

    address: 'Die Anschrift',
    features_and_amenities: 'Funktionen & annehmlichkeiten',
    features_and_amenities_capitalized: 'Funktionen & Annehmlichkeiten',

    cancel_trip_title: 'Stornieren Sie Ihre reise',
    cancel_your_reservation: 'Stornieren Sie Ihre Reservierung',

    payment_form_add_night: 'Fügen Sie eine Nacht hinzu',
    payment_form_add_night_note: 'Ihre neue Check-out-Zeit wird sein',
    payment_form_pricing_details: 'Preisdetails',
    payment_form_pricing_discounted_rent: 'Ermäßigte Miete',
    payment_form_pricing_discount: 'Rabatt',
    payment_form_total: 'Gesamt',
    payment_form_billing_information: 'Abrechnungsdaten',
    payment_form_billing_name: 'Abrechnungsname',
    payment_form_country: 'Land',
    payment_form_city: 'Stadt',
    payment_form_island: 'Insel',
    payment_form_province: 'Provinz',
    payment_form_department: 'Abteilung',
    payment_form_state: 'Zustand',
    payment_form_postal_code: 'Postleitzahl',
    payment_form_zip_code: 'Postleitzahl',
    payment_form_city_or_town: 'Stadt/Gemeinde',
    payment_form_region: 'Region',
    payment_form_county: 'Bezirk',
    payment_form_area: 'Bereich',
    payment_form_parish: 'Gemeinde',
    payment_form_prefecture: 'Präfektur',
    payment_form_emirate: 'Emirat',
    payment_form_governorate: 'Gouvernorat',
    payment_form_card_number: 'Kartennummer',
    payment_form_expiration_date: 'Haltbarkeitsdatum',
    payment_form_expiration_month: 'Monat des Ablaufens',
    payment_form_expiration_year: 'Ablaufjahr',
    payment_form_security_code: 'Sicherheitscode',
    payment_form_payments_note: 'Wir akzeptieren die meisten gängigen Kreditkarten',
    payment_form_pay_now: 'Zahlen Sie jetzt',
    payment_form_visa: 'Visa',
    payment_form_master_card: 'Master',
    payment_form_discover: 'Discover',
    payment_form_reservation_details: 'Reservierungsdetails',
    payment_form_adult: 'Erwachsene',
    payment_form_adults: 'Erwachsene',
    payment_form_child: 'Kind',
    payment_form_children: 'Kinder',
    payment_form_month: 'Monat',
    payment_form_year: 'Jahr',
    payment_successful: 'Alles bereit!',
    payment_successful_note:
        'Genießen Sie diese zusätzliche Nacht des Urlaubs. Unten finden Sie Ihre Zahlungsdetails. In Ihrem Posteingang finden Sie eine Bestätigungs-E-Mail mit Ihren neuen Reisedaten.',
    payment_failed: 'Wir konnten Ihre Zahlung nicht verarbeiten',
    payment_call_us_to_complete: 'Mach dir keine Sorgen - im Moment halten wir die zusätzliche Nacht für dich.',
    payment_call_us_to_complete_start: 'Rufen Sie',
    payment_call_us_to_complete_end: 'an, um telefonisch zu bezahlen und die Änderung Ihrer Reise zu bestätigen.',
    payment_form_removed: 'Enfernt',
    payment_form_added: 'Hinzugefügt',
    payment_successful_generic_note: 'Ihre Reise wird aktualisiert. Hier ist Ihre Zahlungsbestätigung.',
    payment_trip_paid_in_full: 'Ihre Reise ist vollständig bezahlt.',
    payment_successful_add_pet_adjustment_note:
        'Sie haben {total} {pet} zu Ihrem Aufenthalt hinzugefügt. Lassen Sie das Schwanzwedeln beginnen. Hier ist Ihre Zahlungsbestätigung.',
    payment_successful_add_pet_adjustment_refund_note:
        'Sie haben {total} {pet} von Ihrem Aufenthalt entfernt. Wir werden Ihnen innerhalb von 5 Werktagen alle bezahlten Haustiergebühren erstatten.',
    payment_successful_add_pool_heat_adjustment_note:
        'Sie haben die Poolheizung zu Ihrem Aufenthalt hinzugefügt. Hier ist Ihre Zahlungsbestätigung.',

    modal_adjustment_not_available_continue: 'Fortsetzen',
    modal_adjustment_not_available_back_to_trip: 'Zurück zu den Reisedetails',
    modal_adjustment_not_available_title: 'Diese Nacht ist nicht mehr verfügbar',
    modal_adjustment_not_available_note_start:
        'Leider können wir Ihrer Reise keine zusätzliche Nacht hinzufügen. (Ein anderer Gast hat es bereits gebucht oder der Deal ist abgelaufen.)',
    modal_adjustment_not_available_note_end: 'Wir hoffen, Sie haben noch einen schönen Aufenthalt!',

    modal_adjustment_pending_balance_title: 'Zahlen Sie Ihr Guthaben, um dieses Angebot freizuschalten',
    modal_adjustment_pending_balance_note_start:
        'Bevor Sie eine Nacht hinzufügen, müssen Sie den aktuellen Restbetrag für Ihre Reise bezahlen.',
    modal_adjustment_pending_balance_note_end: 'Sobald Sie bezahlt haben, können Sie zu Ihrer E-Mail zurückkehren und es erneut versuchen.',

    modal_lco_adjustment_not_available_title: 'Später Check-out nicht verfügbar',
    modal_lco_adjustment_not_available_note_start:
        'Entschuldigung, wir können das späte Auschecken nicht zu Ihrem Aufenthalt hinzufügen. (das Angebot ist abgelaufen)',
    modal_lco_adjustment_pending_balance_note_start:
        'Bevor du den späten Check-out hinzufügst, musst du den aktuellen Saldo für deine Reise bezahlen.',

    night_added: 'Nacht hinzugefügt',
    nights_added: 'Nächte hinzugefügt',

    maintenance_window_title: 'Diese Seite wird gewartet',
    maintenance_window_note: 'Wir werden sehr bald wieder live sein. Danke für deine Geduld',
    maintenance_go_to_home: 'Zur Startseite gehen',
    maintenance_link: 'https://www.vacasa.com',

    modal_cancel_go_to_my_trips: 'Go to My Trips',
    modal_cancel_title: 'Canceled reservation',
    modal_cancel_note: 'Your reservation has been successfully canceled',

    billing_information_note: 'Bitte überprüfen Sie Ihre Änderungen und bestätigen Sie, um Ihre Reiseaktualisierungen abzuschließen.',

    adjustment_failed_title: 'Wir konnten deine Reise nicht ändern',

    whats_nearby: 'Was ist in der nähe',
    whats_nearby_capitalized: 'Was ist in der Nähe',
    checkout_best_of_city:
        'Sehen Sie sich das Beste von {unitCity} an, während Sie hier sind. Entdecken Sie beliebte Restaurants, Attraktionen und mehr rund um {unitName}.',
    banking: 'Bankwesen',
    restaurants_and_coffee: 'Restaurants & Kaffee',
    groceries: 'Lebensmittel',
    hospitals: 'Krankenhäuser',
    movie_theaters: 'Kinos',
    bars_and_nightlife: 'Bars & Nachtleben',
    parks: 'Parks',
    pharmacies: 'Apotheken',
    shopping: 'Einkaufen',
    sports: 'Sport',
    universities: 'Universitäten',
    tourist_attractions: 'Touristenattraktionen',
    filter_by_category: 'Nach Kategorie filtern',

    star_rating_title: 'Bewerten Sie Ihren Aufenthalt',
    star_rating_note: 'Wie war Ihre Erfahrung bei {unitName}? Ihr Feedback ist uns wichtig.',
    next: 'Nächste',

    pay_balance_issue: 'Rufen Sie {phone} an, um zu bezahlen und die Änderung Ihrer Reise zu bestätigen.',

    chat_default_message: 'Hallo, wie können wir Ihnen heute helfen?',
    chat_default_name: 'Vacasa Customer Service',
    chat_start_new_button: 'Neuen Chat starten',
    chat_start_content: 'Danke, dass Sie mit uns chatten!',
    chat_open: 'Live-Chat ist verfügbar',
    chat_message_close:
        'Leider haben Sie uns außerhalb der Live-Chat-Zeiten erreicht. Für sofortige Hilfe rufen Sie bitte unsere 24-Stunden-Support-Hotline an.',
    chat_rule_close: '{openTime} bis {closeTime}.',
    chat_rule: 'täglich von {openTime} bis {closeTime}.',
    chat_error: 'Fehler beim Initialisieren des Chats',
    chat_loading: 'Wird geladen...',
    chat_me: 'Mir',

    extended_stay_capitalized: 'Verlängert Meinen Aufenthalt',
    extended_stay_rules: 'Wählen Sie bis zu 4 zusätzliche Nächte vor oder nach Ihrer geplanten Reise, um Ihren Aufenthalt zu verlängern.',
    extended_stay_success_alert_plural: '<b>{numberNights} Nächte</b> für <b>{price}</b> zu Ihrem Reiseplan hinzugefügt',
    extended_stay_success_alert: '<b>1 Nacht</b> zu Ihrem Reiseplan hinzugefügt für <b>{price}</b>',
    extended_stay_error_message:
        'Entschuldigung, ein Fehler ist aufgetreten. Um mit einem Kundendienstmitarbeiter zu sprechen, rufen Sie 1-800-544-0300 an',
    extended_stay_note_message: 'Ihre neuen Check-in- und Check-out-Daten werden sein',
    check_in: 'Check in',
    check_in_description: 'Früher verfügbare Check-in-Termine:',
    check_out: 'Check out',
    adult: 'Erwachsener',
    adults: 'Erwachsene',
    check_out_description: 'Später verfügbare Abreisedaten:',
    empty_calendar_before_options: '* Leider sind alle Daten vor Ihrer Reise nicht verfügbar.',
    empty_calendar_after_options: '* Leider sind alle Daten nach Ihrer Reise nicht verfügbar.',
    payment_form_add_extended_stay: '{days} Zusätzliche Nächte',
    today: 'Heute',
    clear: 'Aufräumen',
    checkout: 'Kasse',
    reset_dates: 'Termine Zurücksetzen',
    total_cost: 'Gesamtkosten',

    late_check_out_capitalized: 'Laat uitchecken toevoegen',
    payment_form_add_late_check_out_note: 'Ihre neue Check-out-Zeit wird sein',
    payment_form_add_late_check_out: 'Laat uitchecken toegevoegd',

    bedroom_title: 'Schlafarrangements',
    view_all_beds: 'Alle {total} Schlafmöglichkeiten anzeigen',
    view_less: 'Weniger anzeigen',
    view_more: 'Mehr anzeigen',

    pool_heat_capitalized: 'Poolheizung hinzufügen',

    pal_res_question_panel_text:
        'Dieses Objekt wird von {name} verwaltet. Für Support senden Sie bitte eine E-Mail an {email} oder rufen Sie uns unter {phoneNumber} an.',
    pal_res_question_panel_text_email_only: 'Dieses Objekt wird von {name} verwaltet. Für Support senden Sie bitte eine E-Mail an {email}.',
    pal_res_question_panel_text_phone_only: 'Dieses Objekt wird von {name} verwaltet. Für Support rufen Sie uns unter {phoneNumber} an.',

    pal_cancellation_contact_text:
        'Um eine Stornierung anzufordern, wenden Sie sich bitte an {name} durch Senden einer E-Mail an {email} oder durch Anruf bei {phoneNumber}.',
    pal_cancellation_contact_text_email_only:
        'Um eine Stornierung anzufordern, wenden Sie sich bitte an {name}, indem Sie ihnen eine E-Mail an {email} senden.',
    pal_cancellation_contact_text_phone_only:
        'Um eine Stornierung anzufordern, wenden Sie sich bitte an {name}, indem Sie sie unter {phoneNumber} anrufen.',

    pal_agreement_details_house_rules_text:
        'Bitte nehmen Sie sich einen Moment Zeit, um die folgenden Hausregeln zu lesen. Sie gelten für Ihren Aufenthalt in diesem Zuhause.',
    rental_terms: 'Mietbedingungen',
    view_terms: 'Terms ansehen',
    request_cancellation: 'Stornierung anfragen',
    review_cancellation_policy: 'Stornierungsbedingungen überprüfen',
    pricing_details: 'Preisdetails',
    view_details: 'Details anzeigen',
};
